import { useMemo } from 'react'
import objectPath from 'object-path'
import moment from 'moment'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import TimePickerInput from '../../TimePicker/TimePickerInput'
import { checkLockMode } from '../action/Column'

const CustomTime = ({ id, name, uischema, rowData, onUpdateRowData, column, isTable }) => {
  let { timeFormat } = useTimeFormat()
  let formatTypeTime = objectPath.get(uischema, 'time.formatType')
  let customFormatTime = objectPath.get(uischema, 'time.format')
  let time = objectPath.get(rowData, uischema.field)
  let ampm = objectPath.get(uischema, 'time.ampm')
  let isLockEdit = checkLockMode(column, rowData)
  const formatTime = useMemo(() => {
    if (formatTypeTime === 'custom') {
      return customFormatTime
    }
    return timeFormat
  }, [formatTypeTime, customFormatTime, ampm])

  const updateData = (time) => {
    let value = null
    if (time?.format) {
      value = moment(time.format).format(formatTime)
    } else {
      value = time.value
    }
    objectPath.set(rowData, uischema.field, value)
    onUpdateRowData(rowData)
  }

  return (
    <>
      <div className="d-flex">
        <TimePickerInput
          readOnly={isLockEdit}
          id={id}
          name={name}
          formatDisplay={formatTime}
          ampm={ampm}
          value={time}
          onChange={(e) => {
            let time = { value: e }
            updateData(time, true)
          }}
          uischema={uischema}
          isTable={isTable}
        />
      </div>
    </>
  )
}

export default CustomTime
